module.exports = __webpack_public_path__ + "img/Total SKU Count.72eb355c.svg";